import {TEMP_PATH_PART, type TempExpressionPath} from '../shared';

// Shared by both Dropdown and Navbar plugins (menu open/close state values)
export const MENU_STATE_SHOW = 'show' as const;
export const MENU_STATE_HIDE = 'hide' as const;

export const TEMP_DROPDOWN_MENU_PATH: TempExpressionPath = [
  TEMP_PATH_PART,
  {in: 'Record', at: 'dropdown'},
  {in: 'Record', at: 'menu'},
];
